import { eventChannel } from 'redux-saga';
import { put, takeLatest } from 'redux-saga/effects';
import { API, graphqlOperation } from 'aws-amplify';
import types from './types';
import actions from './actions';
import * as queries from '../../../../graphql/queries';
import * as mutations from '../../../../graphql/mutations';
import * as subscriptions from '../../../../graphql/subscriptions';

function * getCenters () {
  try {
    const centersResponse = yield API.graphql(
      graphqlOperation(queries.listCenters, { limit: 1000 })
    );
    const {
      data: {
        listCenters: { items }
      }
    } = centersResponse;

    yield put(actions.getCentersSuccess(items));
    yield put(actions.subscribeCenters());
  } catch (error) {
    yield put(actions.getCentersFailure(error));
  }
}

function * createCenter (payload) {
  try {
    const { center } = payload;
    yield API.graphql(
      graphqlOperation(mutations.createCenter, { input: center })
    );

    yield put(actions.createCenterSuccess());
  } catch (error) {
    yield put(actions.createCenterFailure(error));
  }
}

function * updateCenter (payload) {
  const { id, center, version } = payload;
  try {
    yield API.graphql(
      graphqlOperation(mutations.updateCenter, {
        input: { ...center, id, expectedVersion: version }
      })
    );

    yield put(actions.updateCenterSuccess(id));
  } catch (error) {
    yield put(actions.updateCenterFailure(id, error));
  }
}

function * deleteCenter (payload) {
  const { id, version } = payload;
  try {
    yield API.graphql(
      graphqlOperation(mutations.deleteCenter, {
        input: { id, expectedVersion: version }
      })
    );

    yield put(actions.deleteCenterSuccess(id));
  } catch (error) {
    yield put(actions.deleteCenterFailure(id, error));
  }
}

let putToCenterSubscriptionChannel;
const centerSubscriptionChannel = (() => {
  return eventChannel(emit => {
    putToCenterSubscriptionChannel = (payload) => {
      emit(payload);
    };
    return () => {};
  });
})();

function * subscriptionMessageReceieved (payload) {
  console.log('Custom payload is ' + payload);
  yield put(payload);
}

let activeSubscriptions = [];

function * subscribeCenters () {
  activeSubscriptions.map((subscription) => subscription.unsubscribe());
  const creationSubscription = yield API.graphql(graphqlOperation(subscriptions.onCreateCenter)).subscribe({
    next: async createdCenter => {
      await putToCenterSubscriptionChannel(
        actions.subscriptionCenterCreated(createdCenter)
      );
    }
  });
  const updateSubscription = yield API.graphql(graphqlOperation(subscriptions.onUpdateCenter)).subscribe({
    next: async updatedCenter => {
      await putToCenterSubscriptionChannel(
        actions.subscriptionCenterUpdated(updatedCenter)
      );
    }
  });
  const deletionSubscription = yield API.graphql(graphqlOperation(subscriptions.onDeleteCenter)).subscribe({
    next: async deletedCenter => {
      await putToCenterSubscriptionChannel(
        actions.subscriptionCenterDeleted(deletedCenter)
      );
    }
  });
  activeSubscriptions = [creationSubscription, updateSubscription, deletionSubscription];
}

function unsubscribeCenters () {
  activeSubscriptions.map((subscription) => subscription.unsubscribe());
}

export const adminCentersSagas = [
  takeLatest(types.GET_CENTERS_REQUEST, getCenters),
  takeLatest(types.CREATE_CENTER_REQUEST, createCenter),
  takeLatest(types.UPDATE_CENTER_REQUEST, updateCenter),
  takeLatest(types.DELETE_CENTER_REQUEST, deleteCenter),
  takeLatest(types.SUBSCRIBE_CENTERS, subscribeCenters),
  takeLatest(types.UNSUBSCRIBE_CENTERS, unsubscribeCenters),
  takeLatest(centerSubscriptionChannel, subscriptionMessageReceieved)
];
